
import { create } from "zustand";
import { devtools } from "zustand/middleware";





const storeApi = (set) => ({

    totalVentaCaja: 0,

});





export const useBuscadorTodoStore = create(
    devtools(
        storeApi
    )
)
